export const products = [
  {
    id: 'gratis-konsultation',
    priceId: 'price_1RQ2uCHVjZFAvFctqbrv5Lcu',
    name: 'Gratis konsultation',
    description: 'Du vil få dine penge refunderet efter dit besøg hos lægen i klinikken. Hvis du ikke møder op, refunderes pengene ikke',
    price: 20000, // 200.00 kr in øre
    currency: 'DKK',
    mode: 'payment' as const
  },
  {
    id: 'fuldt-ansigt-kur-3x',
    priceId: 'price_1RQ1M2HVjZFAvFctlM3Dn98s',
    name: '3x Fuldt ansigt – kur (tilbud)',
    description: 'Mesoterapi i forløb giver glød, opstramning og forbedret hudkvalitet',
    price: 650000, // 6,500.00 kr in øre
    currency: 'DKK',
    mode: 'payment' as const
  },
  {
    id: 'fuldt-ansigt',
    priceId: 'price_1RQ1LcHVjZFAvFctvaXGI35U',
    name: 'Fuldt ansigt',
    description: 'Fugtgivende vitamin og næringscocktail til hele ansigtet',
    price: 215000, // 2,150.00 kr in øre
    currency: 'DKK',
    mode: 'payment' as const
  },
  {
    id: 'behandlinger-kur-3x',
    priceId: 'price_1RQ1L3HVjZFAvFctM3C2THuH',
    name: '3x behandlinger som kur (tilbud)',
    description: 'Kombineret PRP-forløb for maksimalt resultat over tid',
    price: 450000, // 4,500.00 kr in øre
    currency: 'DKK',
    mode: 'payment' as const
  },
  {
    id: 'ampul-enkel',
    priceId: 'price_1RQ1JtHVjZFAvFct75lDhxeH',
    name: '1 ampul (enkel behandling)',
    description: 'Naturlig hudforyngelse med din egen plasma forbedrer glød og struktur',
    price: 170000, // 1,700.00 kr in øre
    currency: 'DKK',
    mode: 'payment' as const
  },
  {
    id: 'juvederm-1ml',
    priceId: 'price_1RQ1JNHVjZFAvFctk1LBn9Ez',
    name: 'Juvederm 1 ml',
    description: 'Premium filler med lang holdbarhed og blød struktur til læber, kinder mm',
    price: 190000, // 1,900.00 kr in øre
    currency: 'DKK',
    mode: 'payment' as const
  },
  {
    id: 'restylane-1ml',
    priceId: 'price_1RQ1IZHVjZFAvFctm5Es3FEB',
    name: 'Restylane 1ml',
    description: 'Hudforbedrende filler med fokus på elasticitet og fugt',
    price: 170000, // 1,700.00 kr in øre
    currency: 'DKK',
    mode: 'payment' as const
  },
  {
    id: 'revolax-1ml',
    priceId: 'price_1RQ1HdHVjZFAvFctiDZbakCv',
    name: 'Revolax 1 ml',
    description: 'Populær filler til konturering og volumen i ansigtet',
    price: 150000, // 1,500.00 kr in øre
    currency: 'DKK',
    mode: 'payment' as const
  },
  {
    id: 'monalise-1ml',
    priceId: 'price_1RQ1H7HVjZFAvFctVcnFlkkr',
    name: 'Monalise 1 ml',
    description: 'Kvalitetsfiller til form og volumen med lang holdbarhed',
    price: 130000, // 1,300.00 kr in øre
    currency: 'DKK',
    mode: 'payment' as const
  },
  {
    id: 'nexfill-1ml',
    priceId: 'price_1RQ1GYHVjZFAvFctemc2lv22',
    name: 'Nexfill 1 ml',
    description: 'Volumenopbyggende filler med naturligt look, perfekt til læber eller kinder',
    price: 120000, // 1,200.00 kr in øre
    currency: 'DKK',
    mode: 'payment' as const
  },
  {
    id: 'pande-botox',
    priceId: 'price_1RQ1FiHVjZFAvFctszkTUuJZ',
    name: 'Pande',
    description: 'Botox til at reducere vandrette linjer og rynker i panden',
    price: 165000, // 1,650.00 kr in øre
    currency: 'DKK',
    mode: 'payment' as const
  },
  {
    id: 'kaebe-botox',
    priceId: 'price_1RQ1FAHVjZFAvFct0AyNRHYF',
    name: 'Kæbe',
    description: 'Botox for at definere kæbelinjen eller afspænde kæbemuskler ved spændinger',
    price: 165000, // 1,650.00 kr in øre
    currency: 'DKK',
    mode: 'payment' as const
  },
  {
    id: 'naserynker-bunny-lines',
    priceId: 'price_1RQ1EeHVjZFAvFctnSJVIaLJ',
    name: 'Næserynker / Bunny lines',
    description: 'Botox til rynker på næseryggen, også kaldet "bunny lines"',
    price: 55000, // 550.00 kr in øre
    currency: 'DKK',
    mode: 'payment' as const
  },
  {
    id: 'loeft-laeber-lip-flip',
    priceId: 'price_1RQ1DVHVjZFAvFctOyOyXsEr',
    name: 'Løft af læber / Lip flip',
    description: 'Botox for et naturligt løft af overlæben giver mere synlig læberkant',
    price: 55000, // 550.00 kr in øre
    currency: 'DKK',
    mode: 'payment' as const
  },
  {
    id: 'rynker-rygning',
    priceId: 'price_1RQ1CFHVjZFAvFctVkiU6bQ7',
    name: 'Rynker fra rygning',
    description: 'Botoxbehandling til rynker forårsaget af rygning. Giver et glattere og mere ungdommeligt udseende',
    price: 55000, // 550.00 kr in øre
    currency: 'DKK',
    mode: 'payment' as const
  }
];

export function getProductByPriceId(priceId: string) {
  return products.find(product => product.priceId === priceId);
}